import React, { useEffect, useState } from 'react';
import { api } from '../lib/api';
import Loader from '../components/Loader';

/* buildersnetwork.xyz/perks/<slug> — a member perk, for signed-in members. */
export default function Perk({ slug, notify, onGo }) {
  const [p, setP] = useState(null);
  const [error, setError] = useState('');
  const [busy, setBusy] = useState(false);
  useEffect(() => { api.perk(slug).then(setP).catch((e) => setError(e.message)); }, [slug]);
  if (error) return <div className="page"><div className="card pad"><p>{error}</p></div></div>;
  if (!p) return <div className="page"><Loader /></div>;
  const claim = async () => {
    setBusy(true);
    try { const r = await api.adClaim(p.id); setP({ ...p, my_code: r.code || '' }); if (!r.code) window.open(r.url, '_blank', 'noopener,noreferrer'); }
    catch (e) { notify?.(e.message); } finally { setBusy(false); }
  };
  const visit = async () => {
    try { const r = await api.adVisit(p.id); window.open(r.url, '_blank', 'noopener,noreferrer'); } catch (e) { notify?.(e.message); }
  };
  const talk = async () => {
    try { await api.adTalk(p.id); notify?.(`Asked the ${p.name} team. If they say yes too, you'll be connected under People.`); }
    catch (e) { notify?.(e.message); }
  };
  return (
    <div className="page">
      <section className="card pad perk-page">
        <span className="sp-label">Member perk</span>
        <div className="sp-body">
          {p.logo_url ? <img className="sp-logo" src={p.logo_url} alt="" /> : <span className="sp-logo sp-initial">{p.name[0]}</span>}
          <div><h1 className="sec-title">{p.name}</h1><p>{p.pitch}</p>
            <span className="muted-sm">by {p.by}{p.by_headline ? ` — ${p.by_headline}` : ''} · {p.domain}</span></div>
        </div>
        {p.perk && <p className="sp-perk">🎁 {p.perk}</p>}
        {p.my_code ? (
          <div className="sp-code"><span className="muted-sm">Your code</span><code>{p.my_code}</code>
            <button className="btn quiet sm" onClick={() => { navigator.clipboard?.writeText(p.my_code); notify?.('Code copied'); }}>Copy</button></div>
        ) : p.perk && <button className="btn primary" disabled={busy} onClick={claim}>Claim perk</button>}
        <div className="sp-actions">
          <button className="btn ghost sm" onClick={talk}>Talk to the team</button>
          <button className="btn quiet sm" onClick={visit}>Visit {p.domain}</button>
          <button className="linklike" onClick={() => onGo('home')}>Back to B/N</button>
        </div>
      </section>
    </div>
  );
}
